import React from "react";
import { useAppSelector, useAppDispatch } from 'redux/hooks'
import {Button} from "primereact/button";
import {setEditType} from "redux/actions/actions";
import {checkPermissions} from "../../../../redux/permissions/permissionsUtils";
import {getRoleDetails} from "../../../../redux/api/apiRoles";
import {setRoleArchiveTableToggle, setRoleDialogVisible, setRoleErrorFields, setRolesClearFilters} from "../../../../redux/actions/actionsRoles";

const RolesListNav = (props: any) => {
    const dispatch = useAppDispatch()
    const rolesVision = useAppSelector(state => state.RolesReducer.rolesVision) as unknown as Record<string, string[]>;
    const dialerPermissions = checkPermissions(rolesVision, 'Role');
    const archiveRolesTableToggle = useAppSelector(state => state.RolesReducer.archiveRolesTableToggle);
    const jwtToken = useAppSelector(state => state.UsersReducer.userData.jwtToken);

    const {
        create: hasRoleCreatePermission,
    } = dialerPermissions;
    return (
        <div className="table-buttons">
            <div>
                <Button onClick={() => { dispatch(setRoleArchiveTableToggle(true))}}
                        label="Ролі"
                        className={archiveRolesTableToggle ? 'mr-2 mb-2' : 'p-button-secondary mr-2 mb-2'}
                />
                <Button onClick={() => { dispatch(setRoleArchiveTableToggle(false))}}
                        label="Архів"
                        className={archiveRolesTableToggle ? 'p-button-secondary mr-2 mb-2' : 'mr-2 mb-2'}
                />
            </div>
            <div className="desktop">
                {hasRoleCreatePermission && (<Button label="Створити роль"
                                                       icon="pi pi-plus"
                                                       className="mr-2 mb-2"
                                                       disabled={!(hasRoleCreatePermission)}
                                                       onClick={() => {
                                                           dispatch(getRoleDetails(0, jwtToken?.jwtToken));
                                                           dispatch(setRoleArchiveTableToggle(true));
                                                           dispatch(setRoleDialogVisible(true));
                                                           dispatch(setRoleErrorFields(null));
                                                           if (hasRoleCreatePermission) {
                                                               dispatch(setEditType(true));
                                                           } else {
                                                               dispatch(setEditType(false));
                                                           }
                                                       }}
                />)}
                <Button type="button" icon="pi pi-filter-slash" label="Очистити фільтри" className="p-button-outlined mr-2 mb-2" onClick={() => {dispatch(setRolesClearFilters()); props.handleReset()}} />
            </div>
            <div className="mobile">
                {hasRoleCreatePermission && (<Button icon="pi pi-plus"
                                                       className="mr-2 mb-2"
                                                       disabled={!(hasRoleCreatePermission)}
                                                       onClick={() => {
                                                           dispatch(getRoleDetails(0, jwtToken?.jwtToken));
                                                           dispatch(setRoleDialogVisible(true));
                                                           dispatch(setRoleArchiveTableToggle(true));
                                                           dispatch(setRoleErrorFields(null));
                                                           if (hasRoleCreatePermission) {
                                                               dispatch(setEditType(true));
                                                           } else {
                                                               dispatch(setEditType(false));
                                                           }
                                                       }}
                />)}
                <Button type="button" icon="pi pi-filter-slash" className="p-button-outlined mr-2 mb-2" onClick={() => {dispatch(setRolesClearFilters()); props.handleReset()}} />
            </div>
        </div>
    )
}

export default RolesListNav;
